import { render, staticRenderFns } from "./tenantPage.vue?vue&type=template&id=3ea089b9&scoped=true&"
import script from "./tenantPage.vue?vue&type=script&lang=js&"
export * from "./tenantPage.vue?vue&type=script&lang=js&"
import style0 from "./tenantPage.vue?vue&type=style&index=0&id=3ea089b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea089b9",
  null
  
)

export default component.exports